import React from 'react'
import Home from './component/Home'
import Project from './component/Project1';
import Pro3 from './component/Pro3';
import Pro2 from './component/Proj2';
import Pro4 from './component/Pro4';
import {
  BrowserRouter as Router,
  Routes,
  Route,
}  from "react-router-dom";
import { HashLink as Link } from 'react-router-hash-link';
import Intro from './component/Intro';
import AllProject from './component/AllProject';
import Skills from './component/Skills';
import Contact from './component/Contact';
import AboutMe from './component/AboutMe';
import Pro5U from './component/Pro5U';
import Pro6U from './component/Pro6U';
function App() {
  return (
    
    <Router>
    <Routes>
      <Route exact path="/" element={<Home/>}/>
      <Route exact path="/Pro1" element={<Project/>}/>
      <Route exact path="/Pro3" element={<Pro3/>}/>
      <Route exact path="/Pro2" element={<Pro2/>}/>
      <Route exact path="/Pro4" element={<Pro4/>}/>
      <Route exact path="/Pro5" element={<Pro5U/>}/>
      <Route exact path="/Pro6" element={<Pro6U/>}/>
      


    </Routes>
  </Router>
  );
}

export default App;
 